import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const filesApi = {
  upload: ({ file, ownerId, ownerRole = "merchant", category, linkedTxId = null }) => {
    const form = new FormData();
    form.append("file", file);
    form.append("owner_id", ownerId);
    form.append("owner_role", ownerRole);
    form.append("category", category);
    if (linkedTxId) form.append("linked_tx_id", linkedTxId);
    return axios.post(`${API}/files/upload`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  list: ({ ownerId, category, linkedTxId }) => {
    const params = new URLSearchParams({ owner_id: ownerId });
    if (category) params.append("category", category);
    if (linkedTxId) params.append("linked_tx_id", linkedTxId);
    return axios.get(`${API}/files/list?${params.toString()}`);
  },
  downloadUrl: (fileId, ownerId) =>
    `${API}/files/${fileId}/download?owner_id=${encodeURIComponent(ownerId)}`,
  remove: (fileId, ownerId) =>
    axios.delete(`${API}/files/${fileId}?owner_id=${encodeURIComponent(ownerId)}`),
  getMerchantProfile: (merchantId) => axios.get(`${API}/profile/${merchantId}`),
};

export const CATEGORIES = {
  logo: { label: "Merchant Logo", accept: "image/*" },
  product: { label: "Product Image", accept: "image/*" },
  invoice: { label: "Invoice / Receipt PDF", accept: "application/pdf,image/*" },
  kyc: { label: "KYC Document", accept: "application/pdf,image/*" },
  attachment: { label: "Transaction Attachment", accept: "image/*,video/*,application/pdf" },
};
